import styled from 'styled-components';

const SiteFooterContainer = styled.div`
    z-index: ${({ inProp }) => (inProp ? 1 : -1)};
`;

export default SiteFooterContainer;
